import { data } from '../../svg/LabelOff/data';
import { makeIcon } from '../makeIcon';

export const LabelOff = makeIcon(data, 'label_off', 'LabelOff');

export default LabelOff;
